export default {
  CLIENT: {
    READY: {
      value: '10',
      text: '대기'
    },
    OK: {
      value: '20',
      text: '사용중'
    },
    DELETE: {
      value: '90',
      text: '중단'
    }
  },
  USER: {
    READY: {
      value: '10',
      text: '대기'
    },
    OK: {
      value: '20',
      text: '사용중'
    },
    BLOCK: {
      value: '40',
      text: '블럭'
    },
    DELETE: {
      value: '90',
      text: '삭제'
    },
    QUIT: {
      value: '99',
      text: '탈퇴'
    }
  },
  CUSTOMER: {
    READY: {
      value: '10',
      text: '대기'
    },
    OK: {
      value: '20',
      text: '사용중'
    },
    DELETE: {
      value: '90',
      text: '중단'
    }
  },
  ROLE: {
    TEST: {
      value: 'test',
      text: '테스터'
    },
    INFLUENCER: {
      value: 'influencer',
      text: '인플루언서'
    },
    USER: {
      value: 'user',
      text: '사용자'
    },
    ADMIN: {
      value: 'admin',
      text: '관리자'
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/status.js